import { t } from "i18next";
import { DataTableData } from "../../../../components/deprecated/DataTable/DataTable";

import { DataObjectHelper, DataObjectType } from "../DataObjects/DataObjectHelper";

export class EmptyDataObjectHelper extends DataObjectHelper<DataObjectType> {
  id = () => "empty";
  displayName = () => t("main.notSpecified");

  getAllDataTableDatas(documents: DataObjectType[]): DataTableData[] {
    return [];
  }
  allFields() {
    return [];
  }
}

